import { useQuery } from "@tanstack/react-query";
import { useEffect, useMemo, useRef, useState } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { getBannerPbf } from "../../../../services/purchaseApi";
import { useNavigate } from "react-router-dom";

const CarouselBanner = () => {
  const navigate = useNavigate();
  const bannerContainerRef = useRef(null);

  const [index, setIndex] = useState(0);

  const changeSlide = (newIndex) => {
    setTimeout(() => {
      setIndex(newIndex);
    }, 200);
  };

  const incrementIndex = () => {
    setIndex((prevVal) => (prevVal + 1 >= bannerArr.length ? 0 : prevVal + 1));
  };

  const decrementIndex = () => {
    setIndex((prevVal) =>
      prevVal - 1 < 0 ? bannerArr.length - 1 : prevVal - 1,
    );
  };

  const { data, isFetching } = useQuery({
    queryKey: ["banner-pbf"],
    queryFn: () => getBannerPbf(),
  });

  const bannerArr = useMemo(() => {
    return data ? data.data : [];
  }, [data]);

  useEffect(() => {
    if (data) setIndex(data.data.length > 1 ? 1 : data.data.length);
  }, [data]);

  useEffect(() => {
    if (bannerArr.length > 1) {
      var interval = setInterval(() => {
        changeSlide(
          index === bannerArr.length * 2 - 1 ? bannerArr.length : index + 1,
        );
      }, 3000);
      return () => clearInterval(interval);
    }
  }, [index]);

  useEffect(() => {
    const banner = document.getElementById(`banner-${index}`);

    if (banner && bannerContainerRef.current) {
      const container = bannerContainerRef.current;

      container.scrollTo({
        left:
          banner.offsetLeft -
          container.clientWidth / 2 +
          banner.clientWidth / 2,
        behavior: "smooth",
      });
    }
  }, [index]);

  return data && !isFetching && bannerArr.length > 0 ? (
    <div>
      <div className="w-full flex items-center justify-center overflow-hidden pt-4 mb-4">
        <div
          ref={bannerContainerRef}
          id="banner-container"
          className="w-[416px] md:w-[1532px] overflow-clip relative flex gap-[8px] overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
        >
          {[...bannerArr, ...bannerArr, ...bannerArr].map((item, i) => (
            <div
              id={`banner-${i}`}
              className={`w-[380px] md:w-[500px] shrink-0 rounded-md overflow-hidden cursor-pointer bg-gray-500 ${i === index ? "" : "scale-[90%]"}`}
              onClick={() => {
                if (i === index)
                  navigate(`/purchase-pbf/banner/${item.banner_uid}`);
                else changeSlide(i === 0 ? bannerArr.length : i);
              }}
            >
              <img
                src={item.image}
                className={`w-[380px] md:w-[500px] aspect-[2/1] object-cover shrink-0 ${i === index ? "" : "opacity-50 blur-[4px]"}`}
              />
            </div>
          ))}
        </div>
      </div>

      <div className="flex gap-2 justify-center items-center">
        {bannerArr.map((_, i) => (
          <div
            key={i}
            className={`rounded-full w-[8px] h-[8px] ${i === index || i === index - bannerArr.length ? "bg-blue-500" : "bg-gray-400"} cursor-pointer hover:bg-gray-500`}
            onClick={() =>
              changeSlide(
                i > bannerArr.length - 1
                  ? i - bannerArr.length
                  : i === 0
                    ? bannerArr.length
                    : i,
              )
            }
          />
        ))}
      </div>
    </div>
  ) : (
    <div className="h-[20px]"></div>
  );
};

export default CarouselBanner;
